import translate from './responsive.language';

class HealthcarebookResponsiveController {
    $onInit() {
        this.translate = translate;
        this.selectedLanguage = localStorage.getItem('languaje') || "en";
    }
}

export default HealthcarebookResponsiveController;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/responsive/responsive.controller.js
// module id = 632
// module chunks = 0